import { render } from "./vr.vue?vue&type=template&id=c6ade07c"
import script from "./vr.vue?vue&type=script&lang=js"
export * from "./vr.vue?vue&type=script&lang=js"

import "./vr.vue?vue&type=style&index=0&id=c6ade07c&lang=css"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__